import Vue from "vue";
import VueI18n from "vue-i18n";

// 导入语言包信息
import en from "./locale/en.json";
import zhCN from "./locale/zh-CN.json";
import tc from "./locale/tc.json";
import ko from "./locale/ko.json";
import ja from "./locale/ja.json";

Vue.use(VueI18n);

// 语言包根据语言环境分类
const messages = {
  en,
  zh: zhCN,
  tc,
  ko,
  ja,
};

// 通过选项创建 VueI18n 实例并导出
export default new VueI18n({
  // 设置当前语言环境，默认中文简体
  locale: "zh",
  // 设置语言环境对应信息
  messages,
});
